import { store } from "../../../redux/store";
import { loginURL } from "apiManager/APIConfig";
import { CallAPI } from "../../../apiManager/ApiCall";
import { setAuth } from "../../../redux/slices/authSlice";
import { userURL } from "apiManager/APIConfig";
import { setAllUsers } from "../../../redux/slices/userSlice";
import { Alert } from "reactstrap";

export const LoginCall = async (body) => {
  try {
    const response = await CallAPI({ url: loginURL, method: "POST", body });
    console.log("pippo response", response);

    if (response?.access_token && response?.role == "admin") {
      store.dispatch(setAuth(response));
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};

export const GetAllUsersCall = async ({ limit = 10, page = 1, search = "" }) => {
  try {
    const response = await CallAPI({
      url: search
        ? `${userURL}?limit=${limit}&page=${page}&search=${search}`
        : `${userURL}?limit=${limit}&page=${page}`,
      method: "GET",
    });

    if (response) {
      store.dispatch(setAllUsers(response));
      return response;
    } else {
      return [];
    }
  } catch (error) {
    return { status: 400 };
  }
};
